import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const deleteServiceProduct = async ({ serviceId, productId }: JsonDataItem) => {
  const { data } = await baseQuery(`service-product/${serviceId}/${productId}`, {
    type: 'DELETE',
  });

  return data;
};
